var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"four wide column"},[_c('div',{staticClass:"listing-buttons"},[_c('button',{staticClass:"ui primary button right floated",on:{"click":function($event){return _vm.add(_vm.route)}}},[_vm._v("Add "+_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }